const toLatinUpper = (text) => {
  if (!text) return "";
  text = text.toUpperCase();
  text = text.replace(/[^A-Z\s'"`(),]/g, "");
  return text;
};
export default toLatinUpper;
